import { sharedDesignTokens } from './desigh-tokens-shared';
import { primitive } from './primitives';

import Styles from '.';

export const designTokens = {
  ...sharedDesignTokens,
  'background-active': primitive.th.$alwaysRed,
  'background-button-hover-reversed': primitive.$whiteOpacity10,
  'background-button-primary-default': primitive.th.$alwaysRed,
  'background-button-primary-default-reversed': primitive.$white,
  'background-button-primary-hover': primitive.th.$alwaysRedDarken10,
  'background-button-secondary-hover': primitive.th.$alwaysRedOpacity10,
  'background-checkbox-disabled': primitive.$blackOpacity30,
  'background-checked': primitive.th.$coffeeBrown,
  'background-chip': primitive.th.$coffeeBrown,
  'background-chip-rewards': primitive.th.$coffeeBrown,
  'background-chip-rewards-locked': primitive.th.$donutCreamLighten20,
  'background-default': primitive.th.$donutCreamLighten20,
  'background-dialog': primitive.$white,
  'background-error': primitive.$error,
  'background-focus': primitive.$blackOpacity4,
  'background-focus-reversed': primitive.$whiteOpacity4,
  'background-footer': primitive.th.$coffeeBrown,
  'background-hero-light': primitive.$white,
  'background-hero-reversed': primitive.th.$alwaysRed,
  'background-icon-hover-focus': primitive.$blackOpacity4,
  'background-icon-hover-focus-reversed': primitive.$whiteOpacity4,
  'background-inline-alert': primitive.$blackOpacity4,
  'background-input': primitive.$white,
  'background-input-disabled': primitive.$blackOpacity4,
  'background-pattern': primitive.$white,
  'background-switch-thumb': primitive.$white,
  'background-switch-track': primitive.th.$coffeeBrown,
  'background-switch-track-disabled': primitive.$blackOpacity30,
  'border-color-active': primitive.th.$alwaysRed,
  'border-color-button-secondary': primitive.th.$alwaysRed,
  'border-color-button-secondary-reversed': primitive.$white,
  'border-color-checked': primitive.th.$coffeeBrown,
  'border-color-default': primitive.$blackOpacity10,
  'border-color-disabled': primitive.$blackOpacity30,
  'border-color-disabled-reversed': primitive.$whiteOpacity30,
  'border-color-error': primitive.$error,
  'border-color-hover': primitive.th.$coffeeBrown,
  'icon-active': primitive.th.$alwaysRed,
  'icon-button-primary': primitive.$white,
  'icon-button-primary-reversed': primitive.th.$coffeeBrown,
  'icon-button-reversed': primitive.$white,
  'icon-button-secondary': primitive.th.$alwaysRed,
  'icon-button-tertiary-default': primitive.th.$coffeeBrown,
  'icon-button-tertiary-hover': primitive.th.$alwaysRed,
  'icon-default': primitive.th.$coffeeBrown,
  'icon-disabled': primitive.$blackOpacity30,
  'icon-disabled-reversed': primitive.$whiteOpacity30,
  'icon-form-checkbox': primitive.$white,
  'icon-form-input-action': primitive.th.$coffeeBrown,
  'icon-form-input-default': primitive.$blackOpacity30,
  'icon-reversed': primitive.$white,
  'padding-button-icon-end': `${primitive.$spacing0} ${primitive.$spacing2} ${primitive.$spacing0} ${primitive.$spacing4}`,
  'padding-button-icon-start': `${primitive.$spacing0} ${primitive.$spacing4} ${primitive.$spacing0} ${primitive.$spacing2}`,
  'padding-button-large': `${primitive.$spacing0} ${primitive.$spacing5}`,
  'padding-button-small': `${primitive.$spacing0} ${primitive.$spacing4}`,
  'padding-input': `${primitive.$spacing0} ${primitive.$spacing4}`,
  'text-active': primitive.th.$alwaysRed,
  'text-button-primary': primitive.$white,
  'text-button-primary-reversed': primitive.th.$coffeeBrown,
  'text-button-reversed': primitive.$white,
  'text-button-secondary': primitive.th.$alwaysRed,
  'text-button-tertiary-default': primitive.th.$coffeeBrown,
  'text-button-tertiary-hover': primitive.th.$alwaysRed,
  'text-default': primitive.th.$coffeeBrown,
  'text-disabled': primitive.$disabledText,
  'text-disabled-reversed': primitive.$disabledTextReversed,
  'text-error': primitive.$error,
  'text-hero-light': primitive.th.$coffeeBrown,
  'text-hero-reversed': primitive.$white,
  'text-link-default': primitive.th.$coffeeBrown,
  'text-link-hover': primitive.th.$alwaysRed,
  'text-link-reversed': primitive.$white,
  'text-reversed': primitive.$white,
  'text-style-back-nav': 'var(--font-copyOne)',
  'text-style-bottom-nav': 'var(--font-copyTwo)',
  'text-style-button-large': 'var(--font-headerThree)',
  'text-style-button-small': primitive.th.$headerFour,
  'text-style-card-copy': 'var(--font-copyTwo)',
  'text-style-card-header': 'var(--font-headerThree)',
  'text-style-chip': 'var(--font-copyTwo)',
  'text-style-chip-rewards': primitive.th.$headerFour,
  'text-style-dialog-copy': 'var(--font-copyOne)',
  'text-style-dialog-header': 'var(--font-headerOne)',
  'text-style-footer-large': 'var(--font-headerThree)',
  'text-style-footer-location': primitive.th.$headerFour,
  'text-style-footer-small': 'var(--font-copyTwo)',
  'text-style-form-checkbox': 'var(--font-copyOne)',
  'text-style-form-checkbox-header': 'var(--font-headerThree)',
  'text-style-form-hint': primitive.th.$formUtility,
  'text-style-form-input': 'var(--font-copyOne)',
  'text-style-form-label-default': 'var(--font-copyOne)',
  'text-style-form-label-value': primitive.th.$formUtility,
  'text-style-form-legend': 'var(--font-headerThree)',
  'text-style-form-options': primitive.th.$formUtility,
  'text-style-hero-header': 'var(--font-hero)',
  'text-style-hero-subheader': 'var(--font-headerThree)',
  'text-style-hero-terms': 'var(--font-copyTwo)',
  'text-style-inline-alert': 'var(--font-copyTwo)',
  'text-style-item-description-copy': 'var(--font-copyTwo)',
  'text-style-item-description-header': 'var(--font-headerThree)',
  'text-style-item-description-price': primitive.th.$headerFour,
  'text-style-item-description-subheader': primitive.th.$formUtility,
  'text-style-list-item': 'var(--font-copyOne)',
  'text-style-list-item-info': 'var(--font-copyTwo)',
  'text-style-list-item-restaurant': 'var(--font-headerThree)',
  'text-style-module': 'var(--font-headerOne)',
  'text-style-segment-header': 'var(--font-headerThree)',
  'text-style-tabs': 'var(--font-copyOne)',
  'text-style-top-nav': 'var(--font-copyOne)',
  'text-style-top-nav-right': primitive.th.$headerFour,
  'text-tabs-default': primitive.th.$coffeeBrown,
  'text-toggle-selected': primitive.$white,
  'transition-component': 'all .3s ease',
  'width-checkbox-radio': '20px',
  'width-icon': '24px',
  'width-icon-small': '16px',
  // Whitelabel-app-specific tokens to be added here, e.g.:
  // 'my-token-name': primitive.$black,
  'background-contrast-loyalty': '',
  'background-badge-cart-entry': primitive.$blackOpacity10,
  'background-icon-header-contrast': primitive.$whiteOpacity4,
  'background-menu-customization-image': '',
  'border-default': `1px solid ${primitive.$blackOpacity10}`,
  'icon-header-contrast': primitive.$white,
  'text-accent-order-number': primitive.th.$alwaysRed,
  'text-loyalty-highlight': '',
  'pickup-timed-fire-selector-button-background': primitive.$white,
  'tims-rewards-text-color': primitive.th.$coffeeBrown,
  'padding-list-item-group-header': `${primitive.$spacing6} ${primitive.$spacing4} ${primitive.$spacing2}`,
  'margin-top-product-wizard-layout': Styles.layout.navHeight.desktop, // app navHeight because TH doesn't have menu option carousel

  // Global App Colors
  'top-nav-bar-background-color': primitive.th.$alwaysRed,
  'bottom-nav-bar-background-color': primitive.$white,
  'main-menu-carousel-background': primitive.$white,
  'bsm-default-background-color': primitive.th.$donutCreamLighten20,
  'bsm-in-progress-background-color': primitive.th.$coffeeBrown,
  'bsm-drop-shadow': '0 0 3px rgb(0 0 0 / 10%)',
};
